import { render, staticRenderFns } from "./DivisionEdit.vue?vue&type=template&id=3ae9fb54"
import script from "./DivisionEdit.vue?vue&type=script&lang=js"
export * from "./DivisionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports